<template>
  <div v-if="showModal">
    <modal :showModal="showModal" :closeModal="closeModal">
      <p class="mx-auto text-xl text-center leading-relaxed text-gray-500">
        Registration completed successfully. Use this registration ID
        <span class="text-2xl font-serif font-extrabold text-black">{{
          rgpId
        }}</span>
        for all your future correspondance with SITRA.
      </p>
    </modal>
  </div>
  <div
    v-else
    id="forms_section"
    class="flex flex-wrap lg:block px-5 py-7 mx-72 w-full lg:w-full lg:mx-5"
  >
    <div id="loder" v-if="loadData">
      <div
        wire:loading
        class="min-h-screen fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center"
      >
        <div
          class="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4"
        ></div>
        <h2 class="text-center text-white text-xl font-semibold">Loading...</h2>
        <p class="w-1/3 text-center text-white">
          This may take a few seconds, please don't close this page.
        </p>
      </div>
    </div>
    <!-- progress bar -->
    <div
      class="hidden lg:block lg:w-full lg:py-1"
      v-if="currentState < steps.length - 1"
    >
      <progressbar :currentState="currentState" :steps="steps" />
    </div>
    <!-- progress bar -->
    <div v-if="() => loader()">
      <keep-alive>
        <component :is="steps[currentState].component" />
      </keep-alive>
      <div
        id="btns"
        class="flex my-6 p-0 justify-center items-center space-x-5"
      >
        <button
          v-if="currentState !== 0"
          @click="prev"
          class="btn bg-blue-500 hover:bg-blue-600"
        >
          Previous
        </button>
        <button
          v-if="currentState < steps.length - 1"
          @click="nxt"
          class="btn bg-blue-500 hover:bg-blue-600"
        >
          Next
        </button>
        <button v-else @click="done" class="btn bg-blue-500 hover:bg-blue-600">
          Done
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import Details from "../../components/Candidate/formsteps/Details.vue";
import Userdetails from "../../components/Candidate/formsteps/Userdetails.vue";
import Edudetails from "../../components/Candidate/formsteps/Educationaldetails.vue";
import employeerecord from "../../components/Candidate/formsteps/Employerecord.vue";
import Langdetails from "../../components/Candidate/formsteps/Languagesdetails.vue";
import Expectation from "../../components/Candidate/formsteps/Expectation.vue";
import { markRaw } from "vue";
import Progressbar from "../../components/Candidate/progressbar.vue";
import Modal from "../../components/Modal.vue";

export default {
  name: "Application",
  components: {
    Details,
    Userdetails,
    Edudetails,
    employeerecord,
    Langdetails,
    Expectation,
    Progressbar,
    Modal,
  },
  mounted() {
    this.loadData = true;
    this.loader();
  },
  data() {
    return {
      loadData: false,
      router: useRouter(),
      showModal: false,
      currentState: 0,
      rgpId: sessionStorage.getItem("id"),
      steps: markRaw([
        {
          component: Userdetails,
          label: "Userdetails",
        },
        {
          component: Edudetails,
          label: "Edudetails",
        },
        {
          component: employeerecord,
          label: "employeerecord",
        },
        {
          component: Langdetails,
          label: "Langdetails",
        },
        {
          component: Expectation,
          label: "Expectation",
        },
        {
          component: Details,
          label: "Details",
        },
      ]),
    };
  },
  methods: {
    loader() {
      setTimeout(() => {
        this.loadData = false;
      }, 4000);
    },
    nxt() {
      this.loadData = true;
      this.currentState += 1;

      this.loader();
    },
    prev() {
      this.currentState -= 1;
    },
    done() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      setTimeout(this.router.push({ name: "overview" }), 1000);
    },
  },
};
</script>

<style scoped>
.loader {
  border-top-color: #3498db;
  -webkit-animation: spinner 1.5s linear infinite;
  animation: spinner 1.5s linear infinite;
}

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
